import React, { useState, useEffect } from 'react';
import Modal from 'react-modal'
import { useMyContext } from 'hooks'
import alertImage from 'assets/alert.svg';

import { ModalContainer, Header, AlertText, Body,Footer, StyledImg } from './styles'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const SerieModal = ({assetsData, selectedPeriod}) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const [ assetsWithoutSeries, setAssetsWithoutSeries  ] = useState([]);
  const { t } = useMyContext();
  const [ hasPeriodChanged, setHasPeriodChanged ] = useState(false);

  useEffect(() => {
    setHasPeriodChanged(true);
  },[selectedPeriod]);

  useEffect(() => {
    if(hasPeriodChanged){
      let nonSeries = [];
      for(let i=0; i< assetsData.length; i+=1){
        if(assetsData[i].rentabilitySeries.length === 0) {
          nonSeries = [ ...nonSeries, assetsData[i].label ];
        }
      }
      setAssetsWithoutSeries(nonSeries);
      setHasPeriodChanged(false);
    }
  }, [assetsData]);

  useEffect(() => {
    if(assetsWithoutSeries.length > 0){
      setIsOpen(true);
    }
  }, [assetsWithoutSeries]);

  return (
    <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
      >
        <ModalContainer>
          <Header>
            <StyledImg src={alertImage} />
            <AlertText>{t['molecules:Modals:SerieModal:alert']}</AlertText>
          </Header>
          <Body>
            {assetsWithoutSeries.map((assetLabel) => (
              <span>{assetLabel}</span>
            ))}
          </Body>
          <Footer>
            <button onClick={() => setIsOpen(false)}>OK</button>
          </Footer>
        </ModalContainer>
      </Modal>
  )
} 


export default SerieModal;